import getEnv from '../utils/getEnv';

// eslint-disable-next-line import/prefer-default-export
export const ORCHESTRATOR_URL = getEnv('REACT_APP_ORCHESTRATOR_URL');
export const CONTACT_PHYSEE = getEnv('REACT_APP_CONTACT_INFO');
export const WITH_CREDENTIALS = getEnv('REACT_APP_WITH_CREDENTIALS');
export const BLOB_STORAGE_URL = getEnv('REACT_APP_BLOB_STORAGE');
export const SVG_CACHE = getEnv('REACT_APP_SVG_CACHE');
